// Lightweight markdown renderer for JotBay reports (headings, bullets, bold, hr).
function inline(text) {
  const parts = [];
  const regex = /\*\*(.+?)\*\*/g;
  let last = 0, m, key = 0;
  while ((m = regex.exec(text)) !== null) {
    if (m.index > last) parts.push(text.slice(last, m.index));
    parts.push(<strong key={key++}>{m[1]}</strong>);
    last = m.index + m[0].length;
  }
  if (last < text.length) parts.push(text.slice(last));
  return parts;
}

export default function MarkdownView({ content }) {
  const lines = (content || "").split("\n");
  const blocks = [];
  let bullets = [];
  let k = 0;

  const flush = () => {
    if (bullets.length) {
      blocks.push(<ul key={k++}>{bullets.map((b, i) => <li key={i}>{inline(b)}</li>)}</ul>);
      bullets = [];
    }
  };

  lines.forEach((raw) => {
    const s = raw.trim();
    if (!s) { flush(); return; }
    if (s === "---") { flush(); blocks.push(<hr key={k++} />); return; }
    if (s.startsWith("### ")) { flush(); blocks.push(<h3 key={k++}>{inline(s.slice(4))}</h3>); }
    else if (s.startsWith("## ")) { flush(); blocks.push(<h2 key={k++}>{inline(s.slice(3))}</h2>); }
    else if (s.startsWith("# ")) { flush(); blocks.push(<h1 key={k++}>{inline(s.slice(2))}</h1>); }
    else if (s.startsWith("- ") || s.startsWith("* ")) { bullets.push(s.slice(2)); }
    else { flush(); blocks.push(<p key={k++}>{inline(s)}</p>); }
  });
  flush();

  return <div className="prose-report" data-testid="report-rendered">{blocks}</div>;
}
